import RequestCallButton from "../CallReqButton";
import "./index.css";

const NRITeam = () => {
  return (
    <section className="nri-bg-container">
      <div className="container-flow text-center mb-5">
        <h1 className="nri-section-heading">Meet Our NRI Team</h1>
        <div className="row justify-content-center align-items-center text-center">
          <div className="col-6 col-md-4 col-lg-3">
            <div className="nri-card-container">
              <img
                src="https://iqteche.in/static/media/wl_client_images/a7a534c732e44822b6ac50ab42b51688.png"
                alt="NRI Team"
                className="nri-img"
              />
              <div className="about-nri">
                <h2>Samuel Mugisha</h2>
                <div className="d-flex justify-content-center">
                  <p>Cameroon</p>
                  <img
                    src="https://iqteche.in/static/media/wl_client_images/64cac3cf72664419ab5304459d6ded8e.png"
                    alt="Cameroon Flag"
                    className="nation-flag ms-3"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="col-6 col-md-4 col-lg-3">
            <div className="nri-card-container">
              <img
                src="https://iqteche.in/static/media/wl_client_images/f540b565c03342d3a6fbe3e74aecbd7a.png"
                alt="NRI Team"
                className="nri-img"
              />
              <div className="about-nri">
                <h2>Vivek Sharma</h2>
                <div className="d-flex justify-content-center">
                  <p>Canada</p>
                  <img
                    src="https://iqteche.in/static/media/wl_client_images/5ade2cdcc5514f02beb085351696671b.png"
                    alt="Canada flag"
                    className="nation-flag ms-3"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="col-6 col-md-4 col-lg-3">
            <div className="nri-card-container">
              <img
                src="https://iqteche.in/static/media/wl_client_images/380e5d012f314bc2877897b607b5db7c.jpg"
                alt="NRI Team"
                className="nri-img"
              />
              <div className="about-nri">
                <h2>Rounaq</h2>
                <div className="d-flex justify-content-center">
                  <p>Dubai</p>
                  <img
                    src="https://iqteche.in/static/media/wl_client_images/f4e300aee9e64a7dadbfc1638d3601cd.png"
                    alt="Dubai flag"
                    className="nation-flag ms-3"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="col-6 col-md-4 col-lg-3">
            <div className="nri-card-container">
              <img
                src="https://iqteche.in/static/media/wl_client_images/bce9a0786aa14c71bf65e8d68727a673.png"
                alt="NRI Team"
                className="nri-img"
              />
              <div className="about-nri">
                <h2>ALI</h2>
                <div className="d-flex justify-content-center">
                  <p>Saudi Arabia</p>
                  <img
                    src="https://iqteche.in/static/media/wl_client_images/2a5d6296e9474f0bb87f5926a4834080.png"
                    alt="Saudi Arabia flag"
                    className="nation-flag ms-3"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <h4> and more...</h4>
      </div>

      <RequestCallButton />
    </section>
  );
};

export default NRITeam;
